export const SUGGEST_REQUEST = 'SUGGEST_REQUEST';
export const CHECK_NAME_REQUEST = 'CHECK_NAME_REQUEST';
export const CREATE_REQUEST = 'CREATE_REQUEST';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const MY_TEAM_REQUEST = 'MY_TEAM_REQUEST';
export const MY_TEAM_SUCCESS = 'MY_TEAM_SUCCESS';
export const LEAVE_TEAM_REQUEST = 'LEAVE_TEAM_REQUEST';
export const LEAVE_TEAM_SUCCESS = 'LEAVE_TEAM_SUCCESS';
export const DISBAND_TEAM_REQUEST = 'DISBAND_TEAM_REQUEST';
export const DISBAND_TEAM_SUCCESS = 'DISBAND_TEAM_SUCCESS';
export const LISTING_TEAMS_REQUEST = 'LISTING_TEAMS_REQUEST';
export const FORGOT_TEAM = 'FORGOT_TEAM';
export const JOIN_TEAM_REQUEST = 'JOIN_TEAM_REQUEST';
export const ACCEPT_JOIN_REQUEST = 'ACCEPT_JOIN_REQUEST';
export const DECLINE_JOIN_REQUEST = 'DECLINE_JOIN_REQUEST';
export const USER_INVITE_REQUEST = 'USER_INVITE_REQUEST';
export const ACCEPT_INVITATION_REQUEST = 'ACCEPT_INVITATION_REQUEST';
export const DECLINE_INVITATION_REQUEST = 'DECLINE_INVITATION_REQUEST';
export const LOAD_TEAM_REQUESTS_REQUEST = 'LOAD_TEAM_REQUESTS_REQUEST';
export const GET_TEAM_DETAIL_REQUEST = 'GET_TEAM_DETAIL_REQUEST';
export const RELOAD_MY_TEAM_MEMBERS_REQUEST = 'RELOAD_MY_TEAM_MEMBERS_REQUEST';
export const RELOAD_MY_TEAM_MEMBERS_SUCCESS = 'RELOAD_MY_TEAM_MEMBERS_SUCCESS';
export const FIRE_TEAM_MEMBER_REQUEST = 'FIRE_TEAM_MEMBER_REQUEST';
export const GET_MY_TEAM_REQUESTS_REQUEST = 'GET_MY_TEAM_REQUESTS_REQUEST';
export const UPDATE_TEAM_REQUEST = 'UPDATE_TEAM_REQUEST';
export const UPDATE_TEAM_SUCCESS = 'UPDATE_TEAM_SUCCESS';
